import { BaseModel } from './BaseModel';
import LearningUnit from './LearningUnit';

export class ReviewFeedback extends BaseModel {
  static get entity() {
    return 'review-feedback';
  }

  static get fk() {
    return 'review_feedback_id';
  }

  static fields() {
    return {
      id: this.attr(null),
      review_response: this.string(''),
      reviewer: this.attr(null),
      learning_unit_id: this.attr(null),
      learning_unit: this.belongsTo(LearningUnit, 'learning_unit_id'),
      attachments: this.attr(null),
      created_at: this.attr(null),
      updated_at: this.attr(null),
      delete_at: this.attr(null)
    };
  }

  static apiConfig = {
    actions: {
      fetch(params = {}) {
        return this.get('/review-feedbacks', { params });
      },

      fetchById(id, params = {}) {
        return this.get(`/review-feedbacks/${id}`, { params });
      },

      create(body) {
        return this.post(`/review-feedbacks`, body);
      },

      update(id, body) {
        return this.put(`/review-feedbacks/${id}`, body);
      },

      destroy(id) {
        return this.delete(`/review-feedbacks/${id}`);
      }
    }
  };
}

export default ReviewFeedback;
